"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypeForMultipleFileExtensions = exports.FILE_EXTENSION_MAPPING = void 0;
const getTypeForMultipleFileExtensions = (fileType, extensions) => extensions.reduce((mapping, extension) => {
  mapping[extension] = fileType;
  return mapping;
}, {});
exports.getTypeForMultipleFileExtensions = getTypeForMultipleFileExtensions;
const FILE_EXTENSION_MAPPING = exports.FILE_EXTENSION_MAPPING = {
  "3ds": "3ds",
  dotx: "dotx",
  dwg: "dwg",
  dwf: "dwf",
  dwfx: "dwfx",
  f3d: "f3d",
  idw: "idw",
  ifc: "ifc",
  iwm: "iwm",
  mat: "mat",
  max: "max",
  maxc: "maxc",
  mcr: "mcr",
  ms: "ms",
  mxp: "mxp",
  nwd: "nwd",
  nwc: "nwc",
  obj: "obj",
  pdf: "pdf",
  potx: "potx",
  ppsx: "ppsx",
  ppt: "ppt",
  rvt: "rvt",
  odp: "odp",
  ods: "ods",
  odt: "odt",
  vssx: "vssx",
  xls: "xls",
  xltx: "xltx",
  ...getTypeForMultipleFileExtensions("archive", ["cab", "7z", "aac", "ace", "alz", "apk", "at3", "bke", "arc", "arj", "ass", "sas", "b", "ba", "big", "bik", "bin", "bkf", "bzip2", "bld", "c4", "cals", "clipflair", "clipflair", "cpt", "sea", "daa", "deb", "dmg", "ddz", "dpe", "egg", "egt", "ecab", "ezip", "ess", "gho", "ghs", "gzip", "gz", "ipg", "jar", "lbr", "lawrence", "lbr", "lqr", "lha", "lzh", "lzip", "lz", "lzo", "lzma", "lzx", "mbw", "mpq", "bin", "nth", "osz", "pak", "par", "par2", "paf", "pyk", "pk3", "pk4", "rar", "rag", "rpm", "sen", "sit", "sitx", "skb", "tar", "tgz", "tb", "tib", "uha", "uue", "viv", "vol", "vsa", "wax", "z", "zoo", "zip"]),
  ...getTypeForMultipleFileExtensions("audio", ["aif", "aifc", "aiff", "bwf", "wav", "la", "pac", "wv", "wma", "mp2", "mp3", "m4a", "mp4", "m4p", "aac"]),
  ...getTypeForMultipleFileExtensions("docx", ["doc", "docm", "docx", "dot", "dotm", "rtf"]),
  ...getTypeForMultipleFileExtensions("image", ["ase", "art", "blp", "bmp", "cd5", "cit", "cpt", "cr2", "cut", "dds", "dib", "djvu", "egt", "exif", "gif", "gpl", "grf", "icns", "ico", "iff", "ilbm", "lbm", "jng", "jpg", "jpeg", "jp2", "jps", "lbm", "max", "miff", "mng", "msp", "nitf", "otb", "pbm", "pc1", "pc2", "pc3", "pcf", "pcx", "pdn", "pgm", "pi1", "pi2", "pi3", "pict", "png", "pnm", "pns", "ppm", "psb", "psd", "pdd", "psp", "px", "pxm", "pxr", "qfx", "raw", "rle", "sct", "sgi", "rgb", "int", "bw ", "tga", "targa", "icb", "vda", "vst", "pix", "tif", "tiff", "vtf", "xbm", "xcf", "xpm"]),
  ...getTypeForMultipleFileExtensions("pptx", ["pot", "potm", "pps", "ppsm", "ppt", "pptm", "pptx"]),
  ...getTypeForMultipleFileExtensions("textfile", ["602", "abw", "acl", "afp", "ami", "ans", "asc", "aww", "ccf", "cwk", "dbk", "egt", "epub", "ezw", "fdx", "ftm", "ftx", "gdoc", "html", "hwp", "hwpml", "log", "lwp", "mbp", "md", "mcw", "mobi", "nb", "nbp", "odm", "ott", "omm", "pages", "pap", "pdax", "quox", "rpt", "sdw", "se", "stw", "sxw", "tex", "info", "troff", "txt", "uof", "uoml", "via", "wpd", "wps", "wpt", "wrd", "wrf", "wri", "xhtml", "xml", "xps"]),
  ...getTypeForMultipleFileExtensions("video", ["aaf", "avi", "3gp", "gif", "avi", "flv", "mpeg", "mpg", "mpe", "ogg", "swf", "wmv", "wtv"]),
  ...getTypeForMultipleFileExtensions("vsdx", ["vsd", "vsdm", "vsdx"]),
  ...getTypeForMultipleFileExtensions("xlsx", ["csv", "xlsb", "xlsm", "xlsx"])
};
//# sourceMappingURL=fileExtensionMapping.js.map